import { TraderType } from 'features/declaration/models/schemas/tradersSchema'
import { createConsignmentDetail } from '../api/createConsignmentDetail'
import { createConsignmentDetailDraft } from '../api/createConsignmentDetailDraft'
import { toConsignmentDetailUpdate } from '../models/mapper'
import { SaveResult } from '../../../../shared/models/types'
import { ConsignmentDetailDetails } from '../models/types'

function useSaveConsignmentDetail() {
  const saveConsignmentDetail = async (
    transitOperationId: number,
    isDraft: boolean,
    trader: TraderType,
  ): Promise<SaveResult<ConsignmentDetailDetails>> => {
    const update = toConsignmentDetailUpdate(transitOperationId, trader)

    try {
      const data = isDraft ? await createConsignmentDetailDraft(update) : await createConsignmentDetail(update)

      return {
        data,
        errors: [],
      }
    } catch (error) {
      console.error('Consignment detail save failed', error)
      return {
        data: null,
        errors: [{ message: 'Consignment detail save failed' }],
      }
    }
  }

  return {
    saveConsignmentDetail,
  }
}

export default useSaveConsignmentDetail
